import SEO from "../components/site/SEO";
import {
  CTASection,
  InfoCard,
  PageHero,
  SectionHeader,
  ServiceCard,
} from "../components/site/Sections";
import {
  imageLibrary,
  primaryServices,
  servicesPageSections,
} from "../content/siteContent";

const ServicesPage = () => (
  <>
    <SEO
      title="Serviços de Engenharia Elétrica | W-Electric Engenharia Elétrica"
      description="Conheça os serviços de manutenção de cabine primária, ensaios elétricos, comissionamento de painéis, consultoria técnica, laudos e fiscalização em São Paulo."
      canonicalPath="/servicos"
      keywords={[
        "serviços de engenharia elétrica em São Paulo",
        "consultoria técnica elétrica",
        "laudos e inspeções elétricas",
        "fiscalização técnica elétrica",
      ]}
    />

    <PageHero
      eyebrow="Portfólio técnico"
      title="Serviços de engenharia elétrica para sistemas críticos"
      description="Atendimento estruturado para manutenção, testes, inspeções, laudos e comissionamento com foco em desempenho, segurança e conformidade normativa."
      image={imageLibrary.industrial}
      ctaMessage="Olá, quero entender qual serviço da W-Electric é ideal para minha operação."
      testId="services-hero"
    />

    <section className="container-shell py-14 md:py-20" data-testid="services-grid-section">
      <SectionHeader
        eyebrow="Especialidades"
        title="Frentes de atuação da W-Electric"
        description="Cada serviço é executado com metodologia de campo, equipamentos apropriados e foco total em reduzir risco operacional."
        testId="services-grid-header"
      />

      <div className="mt-10 technical-grid">
        {primaryServices.map((service, index) => (
          <ServiceCard key={service.title} service={service} index={index} />
        ))}
      </div>
    </section>

    <section className="container-shell py-4 md:py-10" data-testid="services-support-section">
      <div className="grid gap-6 lg:grid-cols-3">
        {servicesPageSections.map((section) => (
          <div id={section.id} key={section.id} className="scroll-mt-28">
            <InfoCard
              title={section.title}
              description={section.description}
              items={section.bullets}
              testId={`services-support-${section.id}`}
            />
          </div>
        ))}
      </div>
    </section>

    <CTASection
      title="Precisa definir o escopo técnico ideal?"
      description="Ajudamos a identificar prioridades, riscos e a melhor estratégia para manter seus sistemas elétricos seguros e confiáveis."
      buttonLabel="Falar com especialista"
      buttonMessage="Olá, preciso de ajuda para definir o escopo de um serviço elétrico."
      testId="services-final-cta"
    />
  </>
);

export default ServicesPage;